export var defaultPagingRequest = {
    skip: 0,
    take: 10,
    orderby: 'CreatedOn',
    asc: -1,
    search: null
};
export var DefaultCatalogParams = {
    t: 'list',
    v: 'my'
};
